import Vue from 'vue'
import VueApollo from 'vue-apollo'
// import VueAnalytics from 'vue-analytics'
// Install the vue plugin
Vue.use(VueApollo)
// Vue.use(VueAnalytics, {
//   id: 'UA-51154111-2',
//   // id: 'UA-110244204-1',
//   checkDuplicatedScript: true,
// })
require('quasar/dist/quasar.ios.css')
import Quasar, * as All from 'quasar'
import CanvasVideo from 'vue-canvasvideo'
import 'vue-canvasvideo/dist/vuecanvasvideo.min.css'

Vue.use(CanvasVideo)
Vue.use(Quasar, {
  components: All,
  directives: All,
}
)



// WEBPACK FOOTER //
// ./src/setup/vue.js